import { httpClientService } from "src/app/services/httpClientService";
import { environment } from "../../environments/environment";

import { Injectable } from "@angular/core";


@Injectable({
  providedIn: "root",
})

export class DashboardControllerApi {
    [x: string]: any;
    constructor(private http: httpClientService) {}
  
    gateWayName = {
      registration: "registration",
      login: "login",
      adminservice: "adminservice",
    };
    API = {
      orderStatistics: environment.prefix + this.gateWayName.adminservice + "/orders/statistics",
      customersStatus: environment.prefix + this.gateWayName.adminservice + "/customer/count/status",
      merchantsStatus: environment.prefix + this.gateWayName.adminservice + "/merchants/count/status",
      };

  
    
  public getUserInfo(userId: any) {
    const getUserInfo =  environment.prefix + this.gateWayName.adminservice + "/user/" +`${userId}`;
    return this.http.get(getUserInfo);
  }

  public getOrdersStatistics() {
    return this.http.get(this.API.orderStatistics);
  }


  public getcustomersStatus() {
    return this.http.get(this.API.customersStatus);
  }

  public getmerchantsStatus() {
    return this.http.get(this.API.merchantsStatus);
  }

  }
  